<template>
  <section class="ff-sidelist">
    <aside v-if="heading" class="ff-sidelist__heading">
      {{heading}}
    </aside>
    <draggable
      class="ff-sidelist__list"
      @change="handleListChange"
      :list="items"
      ghost-class="ghost"
      handle=".handle">
      <ff-sidelist-item
        :class="{
          'is-active': route.page_id == item.id,
          'is-public': item.tier == 'public',
          'is-paid': item.tier == 'paid'
          }"
        :key="item.index"
        v-for="item in orderedItems"
        :action="action"
        :item="item"
        :handle="true"
        />
    </draggable>
  </section>
</template>

<script>
import FFSidelistItem from './FFSidelistItem'
import draggable from 'vuedraggable'
import _ from 'lodash'

export default {
  name: 'ff-sidelist',
  components: {
    'ff-sidelist-item': FFSidelistItem,
    draggable
  },
  props: [
    'heading',
    'items',
    'route',
    'action',
    'listChange'
  ],
  data () {
    return {
    }
  },
  methods: {
    handleListChange (data) {
      return this.listChange(data, this.items)
    }
  },
  computed: {
    orderedItems () {
      return _.orderBy(this.items, 'index', 'asc')
    }
  },
  beforeUpdate () {
    _.each(this.items, (item) => {
      if (!item.index) this.$emit('noindex', item)
    })
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";
</style>
